import {
  EndOfJourneyAnswerInput,
  EndOfJourneyScanItem
} from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function resolveEndOfJourneyScanItem(input: {
  id: number
  enrollmentId: number
  answers: EndOfJourneyAnswerInput[]
  // Replace the questionnaire the youth already has (after the admin confirmed it)
  force?: boolean
}) {
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-scans'].resolveItem.url, { id: input.id }))
    .put<EndOfJourneyScanItem>({
      enrollmentId: input.enrollmentId,
      answers: input.answers,
      force: input.force ?? false
    })
}
